<template>
  <v-card>
    <v-card-title>移動先フォルダ選択</v-card-title>
    <v-card-text>
      <v-radio-group v-model="selectFolder">
        <v-radio
          v-for="(n) in filterFolders"
          :key="n.id"
          :style="`margin-left:${16*n.nestIndex}px;`"
          :value="n.id"
        >
          <template v-slot:label>
            <div>{{ n.name }}</div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="secondary"
        elevation="0"
        style="border-radius: 0px"
        tile
        @click="changeFolderItem(null,null)"
      >
        キャンセル
      </v-btn>
      <v-btn
        color="secondary"
        elevation="0"
        style="border-radius: 0px"
        tile
        @click="changeFolderItem(selectFolder,items)"
      >
        保存
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "SelectFolder",
  props: ["folders", "items", "currentFolderId", "changeFolderItem"],
  data() {
    return {
      selectFolder: this.currentFolderId,
      filterFolders: []
    }
  },
  watch: {
    items: {
      handler() {
        let hasFolders = this.items.some((item) => item.itemType == 0)
        this.filterFolders = []
        if (hasFolders) {
          let nest = -1;
          this.folders.forEach(item => {
            if (this.items.some(someItem => someItem.item.id == item.id) && item.id != -1) {
              nest = item.nestIndex
            } else if (nest == -1 || nest >= item.nestIndex) {
              nest = -1
              this.filterFolders.push(item)
            }
          })
        } else {
          this.filterFolders = this.folders
        }
      }, immediate: true
    }
  }
}
</script>

<style scoped>

</style>